export const INLINE_CAROUSEL_BREAKPOINTS = {
    0: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 16,
    },
    640: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 24,
    },
    768: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
    },
    1024: {
        slidesPerView: 1.1,
        spaceBetween: 16,
    },
    1152: {
        slidesPerView: 1.1,
        spaceBetween: 16,
    },
    1280: {
        slidesPerView: 1.1,
        spaceBetween: 24,
    },
};

export const STANDARD_CAROUSEL_BREAKPOINTS = {
    0: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 16,
    },
    640: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 24,
    },
    768: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
    },
    1024: {
        slidesPerView: 2.1,
        spaceBetween: 16,
    },
    1152: {
        slidesPerView: 2.1,
        spaceBetween: 16,
    },
    1280: {
        slidesPerView: 2.1,
        spaceBetween: 24,
    },
};
